module.exports = __webpack_public_path__ + "static/media/liquity_white.76548c96.png";